export const IconLink: {
  name: 'icon_link-061afa9c09db'
} = {
  name: 'icon_link-061afa9c09db'
}
